<template>
    <div class="lotto-selct-tag">
        <ul class="list">
            <li v-for="( item, index ) in row.content" :key="`btn-${ index }`" :class="{ 'noLastLi': index != row.content.length - 1 }">
                <span v-if="item.bravery? item.bravery.length != 0: false">
                    [ 胆：<circleBtn :list="item.bravery" type="success" :ghost="isLottery" :select="select.selectRedArr"/>]
                </span>
                <span> <circleBtn :list="item.numeric" type="success" :ghost="isLottery" :select="select.selectRedArr"/></span>
            </li>
        </ul>
    </div>
</template>

<script scoped>
    import circleBtn from './circle';
    export default {
        props: [ 'row', 'isLottery', 'select' ],
        components: {
            circleBtn,
        },
        mounted(){
            console.log('row.content', this.row.content)
        }
    };
</script>

<style lang="less" scoped>
    @import '~@/assets/css/common.less';
    .item-btn .ivu-btn{ margin-bottom: 5px 0 !important}
    .lotto-selct-tag{
        .t-c( left ); .m( 0 -16px );
        .list {
            li {
                padding-left: 10px;
                list-style: none;
                border-bottom:solid 1px #d7e1f0;
                &.noLastLi {
                    .mb( 0 );
                }
                &:nth-child(5n){
                    border-bottom:2px solid rgba(60, 69, 78, 0.8);
                }
                &:last-child{
                    border-bottom:0;
                }
            }
        }
    }
</style>